function setStoredPendingFos(pendingFos) {
  sessionStorage.setItem("pendingFos", JSON.stringify(pendingFos));
}
function getStoredPendingFos() {
  return JSON.parse(sessionStorage.getItem("pendingFos"));
}

function setStoredAcceptedFos(AcceptedFos) {
  sessionStorage.setItem("AcceptedFos", JSON.stringify(AcceptedFos));
}
function getStoredAcceptedFos() {
  return JSON.parse(sessionStorage.getItem("AcceptedFos"));
}

function setStoredRejectedFos(RejectedFos) {
  sessionStorage.setItem("RejectedFos", JSON.stringify(RejectedFos));
}
function getStoredRejectedFos() {
  return JSON.parse(sessionStorage.getItem("RejectedFos"));
}
function setStoredReassignFos(ReassignFos) {
  sessionStorage.setItem("ReassignFos", JSON.stringify(ReassignFos));
}
function getStoredReassignFos() {
  return JSON.parse(sessionStorage.getItem("ReassignFos"));
}

function setCountPendingFos(countPendingFos) {
  sessionStorage.setItem("countPendingFos", JSON.stringify(countPendingFos));
}
function getCountPendingFos() {
  return JSON.parse(sessionStorage.getItem("countPendingFos"));
}
function setCountAcceptedFos(countAcceptedFos) {
  sessionStorage.setItem("countAcceptedFos", JSON.stringify(countAcceptedFos));
}
function getCountAcceptedFos() {
  return JSON.parse(sessionStorage.getItem("countAcceptedFos"));
}
function setCountRejectedFos(countRejectedFos) {
  sessionStorage.setItem("countRejectedFos", JSON.stringify(countRejectedFos));
}
function getCountRejectedFos() {
  return JSON.parse(sessionStorage.getItem("countRejectedFos"));
}
function setCountReassignedFos(countReassignFos) {
  sessionStorage.setItem("countReassignFos", JSON.stringify(countReassignFos));
}
function getCountReassignedFos() {
  return JSON.parse(sessionStorage.getItem("countReassignFos"));
}

export {
  setStoredPendingFos,
  getStoredPendingFos,
  setStoredAcceptedFos,
  getStoredAcceptedFos,
  setStoredRejectedFos,
  getStoredRejectedFos,
  setCountPendingFos,
  getCountPendingFos,
  setCountAcceptedFos,
  getCountAcceptedFos,
  setCountRejectedFos,
  getCountRejectedFos,
  getStoredReassignFos,
  setCountReassignedFos,
  getCountReassignedFos,
  setStoredReassignFos,
};
